import { LogCategoryItem, LogCategory } from '@lmc/ts-common'
import { SAFEGUARDING_ITEM_ID } from '@lmc/common/types'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import useSafeguardingAccess from '../components/AccessControl/useSafeguardingAccess'

const unwantedCategories = ['bodyMaps']

export interface IncidentTypeItem {
  label: string
  value: string
  category: string
  image: React.ReactNode
}

const useIncidentTypeOptions = (
  itemsCategoryFilter?: string
): IncidentTypeItem[] => {
  const safeguardingAccess = useSafeguardingAccess()

  const {
    'log-categories': categories,
    'log-category-items': categoryItems
  }: {
    'log-categories': LogCategory[] | undefined
    'log-category-items': LogCategoryItem[] | undefined
  } = useSelector(
    (state: {
      data: {
        'log-category-items': LogCategoryItem[]
        'log-categories': LogCategory[]
      }
    }) => state.data
  )

  const unwantedCategoriesIds = categories
    ?.filter((category) => unwantedCategories.includes(category.itemId))
    .map((category) => category.id)

  const filteredCategoryItems = categoryItems
    ?.filter(
      (categoryItem) => !unwantedCategoriesIds?.includes(categoryItem.category)
    )
    ?.filter((categoryItem) =>
      itemsCategoryFilter
        ? [itemsCategoryFilter].includes(categoryItem.category)
        : true
    )
    ?.filter((categoryItem) =>
      !safeguardingAccess ? categoryItem.id !== SAFEGUARDING_ITEM_ID : true
    )
    .sort((a, b) => {
      if (a.category === b.category) {
        return a.name.localeCompare(b.name)
      }
      return a.category - b.category
    })

  const categoryItemsOptions = (filteredCategoryItems || []).map(
    (categoryItem: LogCategoryItem) => ({
      label: categoryItem.name,
      value: categoryItem.id,
      category: categoryItem.category,
      image: (
        <CategoryImageContainer
          color={
            categories?.find(
              (category) => category.id === categoryItem.category
            )?.color
          }
        >
          <CategoryImage
            src={categoryItem.icon as unknown as string}
            alt="categoryItem"
          />
        </CategoryImageContainer>
      )
    })
  )

  const sortedCategoryItemsOptions = [...categoryItemsOptions]?.sort((a, b) => {
    if (a.category === b.category) {
      return a.label.localeCompare(b.label)
    }
    return a.category.localeCompare(b.category)
  })

  return sortedCategoryItemsOptions
}

const CategoryImageContainer = styled.div<{ color?: string | undefined }>`
  background-color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  overflow: 'hidden';
  width: 20px;
  height: 20px;
`
const CategoryImage = styled.img`
  width: 12px;
  height: 12px;
`

export default useIncidentTypeOptions
